import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const GraduationCapIcon: FC<IconProps> = ({
  color = theme.palette.text.primary,
  size = IconSize.medium,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2385_684)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.5854 8.17221C19.8395 8.0449 20 7.78467 20 7.5C20 7.21533 19.8395 6.9551 19.5854 6.82779L11.7954 2.92472C10.6652 2.35842 9.33481 2.35843 8.20457 2.92472L0.414589 6.82779C0.160502 6.9551 4.97728e-08 7.21533 0 7.5C-4.97728e-08 7.78467 0.160501 8.0449 0.414589 8.17221L3.25012 9.59291L3.25012 13C3.25012 14.2655 4.25656 15.2094 5.42207 15.7921C5.48854 15.8254 5.55624 15.8578 5.62512 15.8895L5.62512 17.0727C5.25864 17.221 5.00012 17.5803 5.00012 18V19C5.00012 19.5523 5.44784 20 6.00012 20C6.55241 20 7.00012 19.5523 7.00012 19V18C7.00012 17.5803 6.7416 17.221 6.37512 17.0727L6.37512 16.1879C7.42892 16.5482 8.67778 16.75 10.0001 16.75C11.7482 16.75 13.3678 16.3973 14.5782 15.7921C15.7437 15.2094 16.7501 14.2655 16.7501 13L16.7501 9.59279L19.5854 8.17221ZM6.37512 14.5817C7.31546 14.9883 8.58176 15.25 10.0001 15.25C11.5658 15.25 12.9462 14.9311 13.9074 14.4505C14.9134 13.9475 15.2501 13.3913 15.2501 13L15.2501 10.3443L11.7954 12.0753C10.6652 12.6416 9.33482 12.6416 8.20457 12.0753L6.37512 11.1587L6.37512 14.5817ZM5.62512 14.1832V10.7829L4.75012 10.3445V13C4.75012 13.3229 4.97946 13.7582 5.62512 14.1832ZM2.42704 7.5L5.79083 9.18538L8.22992 7.96584C8.08319 7.82672 8.00012 7.66821 8.00012 7.5C8.00012 6.94772 8.89555 6.5 10.0001 6.5C11.1047 6.5 12.0001 6.94772 12.0001 7.5C12.0001 8.05229 11.1047 8.5 10.0001 8.5C9.6637 8.5 9.34668 8.45847 9.06845 8.3851L6.62849 9.60508L8.87539 10.7309C9.58335 11.0856 10.4166 11.0856 11.1246 10.7309L17.573 7.5L11.1246 4.26914C10.4167 3.91443 9.58334 3.91443 8.87538 4.26914L2.42704 7.5Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_2385_684">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  </>
)
